import { PropsWithChildren } from "react";
import st from "./index.module.scss";

export default function Container({ children }: PropsWithChildren) {
  return <div className={st.container}>{children}</div>;
}
